module.exports = __webpack_public_path__ + "img/tag.fb4b36cf.svg";